<template>
  <v-snackbar v-model="snackbar" :color="color" :timeout="timeout" top>
    <div :style="`width:${noticeWidth}px; word-wrap: break-word`">{{ text }}</div>
    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        text
        v-bind="attrs"
        @click="closeSnackbar()">
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    value: Boolean,
    text: String,
    noticeType: String,
    closeCallback: Function
  },
  computed: {
    color() {
      switch (this.noticeType) {
        case 'warning':
          return 'warning';
        case 'error':
          return 'error';
        case 'success':
          return 'success';
        default:
          return 'info';
      }
    },
    noticeWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 250;
        case 'sm': return 400;
        default: return 500;
      }
    },
    snackbar: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },
    timeout() {
      if (this.noticeType === 'error' || this.noticeType === 'info') {
        return 0;
      } else if (this.noticeType === 'warning') {
        return 10000;
      } else { // success
        return 5000;
      }
    }
  },
  methods: {
    closeSnackbar() {
      this.snackbar = false;
      if (this.closeCallback) this.closeCallback();
    }
  }
}
</script>